import { render, staticRenderFns } from "./BlockType29.vue?vue&type=template&id=6ed90e3e&scoped=true"
import script from "./BlockType29.vue?vue&type=script&lang=ts"
export * from "./BlockType29.vue?vue&type=script&lang=ts"
import style0 from "./BlockType29.vue?vue&type=style&index=0&id=6ed90e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed90e3e",
  null
  
)

export default component.exports